import { Passkey } from '@ul/api';

const passkeys: Passkey[] = [
    {
        credentialId: 'cred-1-AbCdEfGhIjKlMnOpQrStUvWxYz123456',
        friendlyName: 'MacBook Pro Touch ID',
        location: 'Bangkok',
        rpId: 'localhost',
        createdAt: 1705640000000,
        lastUsedAt: 1707820000000,
    },
    {
        credentialId: 'cred-1-AbCdEfGhIjKlMnOpQrStUvWxYz123456',
        friendlyName: 'Iphone 15 Pro Face ID',
        location: 'Bangkok',
        rpId: 'localhost',
        createdAt: 1705640000000,
        lastUsedAt: 1707820000000,
    },
    {
        credentialId: 'cred-1-AbCdEfGhIjKlMnOpQrStUvWxYz123456',
        friendlyName: 'Iphone 16 Pro Face ID',
        location: 'Bangkok',
        rpId: 'localhost',
        createdAt: 1705640000000,
        lastUsedAt: 1707820000000,
    },
];

export { passkeys };
